import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from "rxjs/operators";
import { AppServiceHelperService } from '../../../services/app-service-helper.service';

/**
 * Injectable
 */
@Injectable({
  providedIn: 'root'
})
export class ValuationEventParticipantsService {
  /**
   * Constructor
   * @param ais
   * @param httpClient
   */
  constructor(private httpClient: HttpClient, private appServiceHelper: AppServiceHelperService) {
  }

  /**
   * Saves parcticipants assigments
   */
  saveParticipantsAssignments(oid: number, assignments: any): Observable<any> {
    return this.httpClient.post<any>(this.appServiceHelper.getServiceEndpoint('pollux.projectValuation.api', `ValuationPortfolios/externals?oid=${oid}&assignments=?`), assignments).pipe(
      map((data) => {
        if (!data.m_Item1) {
          alert("Failed to save participants assignments");
        }
        return data.m_Item1;
      })
    );
  }
}
